import type { UiIconName } from "@dpa-id-components/dpa-shared-components/src/components/UiIcon/UiIcon.vue";
import { computed, ref } from "vue";

const IS_SHOWN = ref(false);
const MESSAGE = ref("");
const TIMEOUT = 3000;
const ACTION = ref("");
const ICON_NAME = ref<UiIconName>();

export default () => {
  const isShown = computed(() => IS_SHOWN.value);
  const message = computed(() => MESSAGE.value);
  const action = computed(() => ACTION.value);
  const iconName = computed(() => ICON_NAME.value);

  const showMessage = ({
    message,
    action = "",
    noTimeout = false,
    iconName = undefined,
  }: {
    message: string;
    action?: string;
    noTimeout?: boolean;
    iconName?: UiIconName;
  }) => {
    MESSAGE.value = message;
    IS_SHOWN.value = true;
    ACTION.value = action;
    ICON_NAME.value = iconName;
    if (!noTimeout) {
      setTimeout(() => {
        MESSAGE.value = "";
        IS_SHOWN.value = false;
        ACTION.value = "";
        ICON_NAME.value = undefined;
      }, TIMEOUT);
    }
  };

  return { isShown, message, action, showMessage, iconName };
};
